import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Button, Stack } from "@mui/material";
import classNames from 'classnames';
import React, { memo, useCallback, useContext, useRef } from "react";
import { ReactComponent as User } from "../../../../../assets/icons/user.svg";
import { DashboardsTableContext } from '../../../../../contexts/TablesContext/DashboardsTableProvider';
import theme from '../../../../../theme';
import useStyles from "../styles";

const OwnerColumn: React.FC<{}> = () => {
    const classes = useStyles();
    const { filters, setFilters, setModalContext } = useContext(DashboardsTableContext);
    const anchorRef = useRef<HTMLDivElement>(null);

    const handleModalOpen = useCallback(() => {
        setModalContext({
            open: 'OwnerFilterModal',
            field: 'Owner',
            anchorElement: anchorRef.current,
            onClose: () => setModalContext({}),
        });
    }, [setModalContext]);

    return (
        <Stack direction="row" className={classNames(classes.header, classes.hoverHeader)}
            spacing={1} alignItems="center" justifyContent="flex-start" width="100%" ref={anchorRef}
            onClick={handleModalOpen}>
            <User style={{ minWidth: 24, maxWidth: 24, height: 24, stroke: 'rgb(163, 167, 172)' }} />
            <span>{'Owner'}</span>
            {!!filters.owners?.length ? (<>
                <FilterAltIcon sx={{ width: 24, height: 24, color: theme.palette.primary.main }} />
                <Button variant="text"
                    className={classes.clear}
                    onClick={() => setFilters(prev => ({...prev, owners: [] }))}
                    disableRipple> {'clear'} </Button>
            </>) : (
                <ExpandMoreIcon
                    sx={{ color: theme.colors.neutral['600'],
                        "&:hover": { color: theme.colors.neutral['900'] } }} />
            )}
        </Stack>
    );
}

export default memo(OwnerColumn);